export default __webpack_public_path__ + "static/media/wa-1715-1.65997954.jpg";